import React from 'react';

export const HTMLContent = ({ content, className = '' }) => (
  <div
    className={`md-content ${className}`}
    dangerouslySetInnerHTML={{ __html: content }}
  />
);
